import { Component, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { DaoService } from '../../../core/dao/dao.service';
import { IMenuItem } from '../../../core/models/plugin.model';

@Component({
  selector: 'app-admin-plugin-detail',
  templateUrl: './admin.plugin.detail.html',
  styleUrls: ['./admin.plugin.detail.scss']
})
export class AdminPluginDetailGridComponent implements AfterViewInit {
  @Input() data!: any;
  @Output() saveGridEvent = new EventEmitter<any>();

  menuItemsDataSource!: DataSource;
  menuItemsColumns: any[] = [];
  constructor(private dao: DaoService) {
    this.initMenuItemsGrid();
  }

  initMenuItemsGrid() {

    this.menuItemsColumns = [
      {
        dataField: "description",
        allowEditing: true,
        width: "200px",
        formItem: {
          colSpan: 2,
          editorType: "dxHtmlEditor",
          editorOptions: {
            height: 500,
            toolbar: {
              items: [
                'undo', 'redo', 'separator',
                {
                  name: 'size',
                  acceptedValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
                },
                {
                  name: 'font',
                  acceptedValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
                },
                'separator', 'bold', 'italic', 'strike', 'underline', 'separator',
                'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'separator',
                'orderedList', 'bulletList', 'separator',
                {
                  name: 'header',
                  acceptedValues: [false, 1, 2, 3, 4, 5],
                }, 'separator',
                'color', 'background', 'separator',
                'link', 'image', 'separator',
                'clear', 'codeBlock', 'blockquote', 'separator',
                'insertTable', 'deleteTable',
                'insertRowAbove', 'insertRowBelow', 'deleteRow',
                'insertColumnLeft', 'insertColumnRight', 'deleteColumn',
              ],
            },
            mediaResizing: {
              enabled: true,
            },
          }
        }
      },
      {
        dataField: "item",
        allowEditing: true
      },
      {
        dataField: "menuId",
        allowEditing: true
      },
      {
        dataField: "caption",
        allowEditing: true
      },
      {
        dataField: "blob",
        allowEditing: true,
        width: "150px"
      }
    ]
  }

  ngAfterViewInit() {
    this.menuItemsDataSource = new DataSource({
      store: new ArrayStore({
        data: this.data.row.data.menuItems
      })
    });
  }


  onPluginsGridSaving(event: any) {
    this.saveGridEvent.emit(event);
  }
}
